import { render } from "./UserPayments.vue?vue&type=template&id=41e7d540&scoped=true"
import script from "./UserPayments.vue?vue&type=script&lang=js"
export * from "./UserPayments.vue?vue&type=script&lang=js"

import "./UserPayments.vue?vue&type=style&index=0&id=41e7d540&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e7d540"]])

export default __exports__